import React, { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import DealsCard from './cards/DealsCard'
import DealsCardMobile from './cards/DealsCardMobile'
import { nanoid } from 'nanoid'
import darkTheme from '../src/theme';
import axios from 'axios'
import Skeleton from "@mui/material/Skeleton";
import { parseCookies } from "nookies";

let skeletonCards = Array(10).fill(0);

const dealsContainer = {
    marginTop: darkTheme.spacing(3),
    marginBottom: darkTheme.spacing(3),
    '& h2': {
        fontSize: 22,
        [darkTheme.breakpoints.down("md")]: {
            marginBottom: darkTheme.spacing(1),
            marginTop: darkTheme.spacing(1),
            fontSize: 18,
        }
    }
};
function HomeDeals(props) {     
    const [rdeals, setRDeals] = useState([])
    const [loading, setLoading] = useState(true);
    const [cityName, setCityName] = useState('');
    const cookieCity = parseCookies();

    useEffect(async() => {
        const city = cookieCity.city ? cookieCity.city : "";
        if (city) {
            setCityName(city);
        } else {
            setCityName("");
        }
        // if (cityName) {            
            await axios.get(
                `/api/deals/similarDeals?dealId=${props.id}&city=${cityName}`, {
                headers: {
                    "x-auth-token": process.env.JWT_TOKEN,
                },
            }).then((response) => {  
                // console.log(response.data);
                if (response.status == 200) {                
                    setRDeals(response.data.result)
                    setLoading(false);
                }
            }) 
        // } else {
        //     setRDeals([])
        //     setLoading(false);
        // }
    }, [props, cityName]);

    return (
        <>
            {loading ? (
                <Typography component="div" sx={dealsContainer}>   
                    <Skeleton
                        animation="wave"
                        variant="rectangular"
                        height={20}
                        width={300}
                        sx={{ mb:3}}                            
                    />       
                    <Grid container spacing={0}>                            
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={30}                                                   
                            navigation                        
                            autoplay={true}
                            loop={false}
                            slidesPerView={1.05}
                            breakpoints={{
                                1023: {
                                    width: 1023,
                                    slidesPerView: 1.75,
                                },
                                990: {
                                    width: 990,
                                    slidesPerView: 1.3,
                                },
                                768: {
                                    width: 768,
                                    slidesPerView: 1.25,
                                },
                                425: {
                                    width: 425,
                                    slidesPerView: 1.05,
                                },
                            }}
                        >
                        {skeletonCards.map((index) => (
                            <SwiperSlide >                                 
                                <Skeleton
                                    animation="wave"
                                    variant="rectangular"
                                    height={200}
                                    sx={{ borderRadius: darkTheme.spacing(1) }}
                                    key={"sk" + index}
                                />                                                            
                            </SwiperSlide>
                        ))}
                        </Swiper>
                    </Grid>          
                </Typography>
            ) : (
                    <>
                        {rdeals.length > 0 ? (
                            <>
                                <Typography component="div" sx={dealsContainer} className="desktopMode">
                                <Typography variant="h2" sx={{ pb: 3 }}>Discover Similar Deals <Typography variant="span" sx={{ textTransform: 'capitalize !important' }}>{`in ${cityName}`}</Typography></Typography>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    spaceBetween={30}
                                    navigation
                                    autoplay={true}
                                    loop={false}
                                    slidesPerView={1.25}
                                    breakpoints={{
                                        1023: {
                                            width: 1023,
                                            slidesPerView: 1.75,
                                        },
                                        990: {
                                            width: 990,
                                            slidesPerView: 1.3,
                                        },
                                        768: {
                                            width: 768,
                                            slidesPerView: 1.25,
                                        },
                                        425: {
                                            width: 425,
                                            slidesPerView: 1.25,
                                        },
                                    }}
                                >
                                    {rdeals.map((deal) => (
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={nanoid(30)}>
                                            <SwiperSlide >
                                                <DealsCard data={deal} />
                                            </SwiperSlide >
                                        </Grid>
                                    ))}
                                </Swiper>
                                </Typography>
                                <Typography component="div" sx={dealsContainer} className="mobileMode">
                                <Typography variant="h2" sx={{ pb: 3 }}>Discover Similar Deals <Typography variant="span" sx={{ textTransform: 'capitalize !important' }}>{`in ${cityName}`}</Typography></Typography>
                                    <Swiper
                                        modules={[Navigation, Pagination, Autoplay]}
                                        spaceBetween={30}
                                        navigation
                                        autoplay={true}
                                        loop={false}
                                        slidesPerView={1.25}
                                        breakpoints={{
                                            1023: {
                                                width: 1023,
                                                slidesPerView: 1.75,
                                            },
                                            990: {
                                                width: 990,
                                                slidesPerView: 1.3,
                                            },
                                            768: {
                                                width: 768,
                                                slidesPerView: 1.25,
                                            },
                                            425: {
                                                width: 425,
                                                slidesPerView: 1.25,
                                            },
                                        }}
                                    >
                                        {rdeals.map((deal) => (
                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={nanoid(30)}>
                                                <SwiperSlide >
                                                    <DealsCardMobile data={deal} />
                                                </SwiperSlide >
                                            </Grid>
                                        ))}
                                    </Swiper>
                                </Typography>
                            </>
                        ) : ('')}
                    </>
            )}
        </>
    )
}


export default HomeDeals
